import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupportComponent } from './support.component';


const routes: Routes = [
  {
    path: '',
    component: SupportComponent,
    children: [
      //{ path: 'alerts', component: AlertsComponent },
      //{ path: 'about', component: AboutComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportRoutingModule { }
